import script from "./preview.vue?vue&type=script&setup=true&lang=js"
export * from "./preview.vue?vue&type=script&setup=true&lang=js"

import "./preview.vue?vue&type=style&index=0&id=7c4cc9ce&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4cc9ce"]])

export default __exports__